import { Link } from 'gatsby'
import React from 'react'
import { motion } from 'framer-motion'
const NavModuleLinks = ({routeName}) => {
    return (
        <motion.div 
            className='flex nav-module-links'
            initial={{ opacity: 0}}
            animate={{ opacity: 1}}
            exit={{ opacity: 0 }}
            transition={{delay: .25}}
        >
            <Link to="/about/"><div className={`nav-link nav-link-0 ${routeName === "about" ? "active" : ""}`}>About</div></Link>
            <Link to="/articles/"><div className={`nav-link ${routeName === "articles" ? "active" : ""}`}>Articles</div></Link>
            <Link to="/community/"><div className={`nav-link ${routeName === "community" ? "active" : ""}`}>Community</div></Link>

        </motion.div>
    )
}

export default NavModuleLinks